import { Color } from '../../../../../../enums/color'
import { Flex } from '../../../../../Flex'
import { Icon } from '../../../../../Icon'
import { Text } from '../../../../../Text'
import { Tooltip } from '../../../../../Tooltip'

interface DescriptionSuffixProps {
  name?: string
  description?: string
}

export const DescriptionSuffix = ({ name, description }: DescriptionSuffixProps) => {
  if (!name && !description) {
    return null
  }

  const tooltipLabel = (
    <Flex as="span" flexDirection="column" alignItems="center">
      {name && (
        <Text as="span" color={Color.White} weight="medium">
          {name}
        </Text>
      )}
      {description && (
        <Text as="span" color={Color.White}>
          {description}
        </Text>
      )}
    </Flex>
  )

  return (
    <Tooltip label={tooltipLabel} placement="right">
      <Icon icon="info" />
    </Tooltip>
  )
}
